import react from 'react'

export default function PartyDetails() {
    return (

        <div>party videos </div>
    )






}